import Menu from 'ui/Menu';

import { useSankeyFormContext } from '../../../contexts/sankeyFormContext';
import { useCurrentUser } from '../../../utils/user';
import ShareDiagramDialog from '../../ShareDiagramDialog';
import BlockedMenuItem from '../BlockedMenuItem';
import TrackedMenuItem from '../TrackedMenuItem';

const ShareDiagramMenuItem: React.FC = () => {
  const { isReadOnly } = useSankeyFormContext();
  const { user } = useCurrentUser();

  if (!user?.can_update_sankeys) {
    return (
      <BlockedMenuItem
        value="share"
        label="Share"
        conversionTriggerAction="Sharing"
      />
    );
  }

  if (isReadOnly) {
    return (
      <Menu.Item value="share" disabled>
        Share
      </Menu.Item>
    );
  }

  return (
    <ShareDiagramDialog>
      <TrackedMenuItem value="share">Share</TrackedMenuItem>
    </ShareDiagramDialog>
  );
};

export default ShareDiagramMenuItem;
